"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var WindowDerivedData_1 = require("../model/WindowDerivedData");

var WindowDerivedDataConverter_1 = require("./WindowDerivedDataConverter");
/**
 * Implementation of {@link WindowDerivedDataConverter}.
 *
 * @author JMt
 */


var WindowDerivedDataConverterImpl =
/*#__PURE__*/
function (_WindowDerivedDataCon) {
  _inherits(WindowDerivedDataConverterImpl, _WindowDerivedDataCon);

  function WindowDerivedDataConverterImpl() {
    _classCallCheck(this, WindowDerivedDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowDerivedDataConverterImpl).apply(this, arguments));
  }

  _createClass(WindowDerivedDataConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowDerivedData_1.WindowDerivedData(WindowDerivedData_1.WindowDerivedData.schema.leadingProductPrice.valueOf(index_1.Utils.isValueMissing(source.leadingProductPrice) ? null : conversions.toBigNumber(source.leadingProductPrice)), WindowDerivedData_1.WindowDerivedData.schema.leadingProductDiscount.valueOf(index_1.Utils.isValueMissing(source.leadingProductDiscount) ? null : conversions.toBigNumber(source.leadingProductDiscount)), WindowDerivedData_1.WindowDerivedData.schema.varyingPrice.valueOfField(source), WindowDerivedData_1.WindowDerivedData.schema.varyingDiscount.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        leadingProductPrice: index_1.Utils.isValueMissing(source.leadingProductPrice) ? null : conversions.fromBigNumber(source.leadingProductPrice),
        leadingProductDiscount: index_1.Utils.isValueMissing(source.leadingProductDiscount) ? null : conversions.fromBigNumber(source.leadingProductDiscount),
        varyingPrice: source.varyingPrice,
        varyingDiscount: source.varyingDiscount
      });
      return result;
    }
  }]);

  return WindowDerivedDataConverterImpl;
}(WindowDerivedDataConverter_1.WindowDerivedDataConverter);

exports.WindowDerivedDataConverterImpl = WindowDerivedDataConverterImpl;